import React from "react";
import { Badge } from "@mantine/core";
import {
    getDaysUntil,
    getDeadlineBadgeColor,
} from "../../utils/hotelBookingUtils";

type Props = {
    paymentDeadline?: string | null;
    language: "en" | "da";
};

/*
    VIGTIGT:
    Denne kræver at din HotelBookingDto har paymentDeadline/paymentDeadline felt.
    Hvis feltet hedder noget andet i API'et, så ret prop'en i BookingCard.
*/

export default function PaymentDeadlineBadge({ paymentDeadline, language }: Props) {
    const daysLeft = getDaysUntil(paymentDeadline);

    if (daysLeft === null) return null;

    let text = "";

    if (daysLeft <= 0) {
        text = language === "en" ? "Payment deadline passed" : "Betalingsfrist overskredet";
    } else if (daysLeft === 1) {
        text = language === "en" ? "Payment: 1 day left" : "Betaling: 1 dag tilbage";
    } else {
        text = language === "en"
            ? `Payment: ${daysLeft} days left`
            : `Betaling: ${daysLeft} dage tilbage`;
    }

    return (
        <Badge color={getDeadlineBadgeColor(daysLeft)} variant="light">
            {text}
        </Badge>
    );
}
